
import React from 'react';
import styles from './Hints.module.scss';

export const hintsArray = [
    <>
        <h4>Welcome to Catchphrase!</h4>
        Work out the hidden catchphrases from the clues on screen! <br />
        Buzz in, answer, and rack up points.
    </>,
    <>
        <h4>Game Setup</h4>
        Before each game, one player picks the settings on their phone (the host TV mirrors every change). <br />
        <span className={styles.yellow}>Length</span>: Short (~15 min) or Long (~30 min). <br />
        <span className={styles.yellow}>Players</span>: Solo (score for yourself) or Teams (share a score, needs 2+ players). <br />
        <span className={styles.yellow}>Answers</span>: Say It (close matches count) or Type It (exact spelling required, slots on your phone). <br />
        Tap the ⓘ next to any setting for the full description.
    </>,
    <>
        <h4>Round 1</h4>
        Buzz in when you think you know the answer. <br />
        You only get <span className={styles.red}>one chance</span> — if you get it wrong, you're out for that catchphrase! <br />
        Answer by typing or using Hold to Speak. You can also pass if you really don't know.
    </>,
    <>
        <h4>Round 2</h4>
        Buzz in as much as you like! Even if you get it wrong, you can buzz back in and try again. <br />
        But be quick — others are trying to answer too! <br />
        Same as Round 1, you can type or speak your answer.
    </>,
    <>
        <h4>Round 3: Money Drop</h4>
        Everyone answers at the same time! <br />
        The quicker you answer, the <span className={styles.green}>more points</span> you get. <br />
        Voice is disabled this round — type only so you don't give away your answer!
    </>,
    <>
        <h4>The Bonus Board</h4>
        In Rounds 1 & 2, catchphrases are hidden behind a bonus board of segments. <br />
        When the buzzer turns <span className={styles.yellow}>gold</span>, buzz in to select a segment to reveal. <br />
        The round ends when someone guesses correctly, or after all segments are revealed and no one gets it.
    </>,
    <>
        <h4>Tips</h4>
        Watch the main screen for visual clues. <br />
        Good luck!
    </>,
];

const Hints = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className={styles.hintsBackground}>
            <div className={styles.hintsContainer}>
                <button className={styles.closeButton} onClick={onClose}>
                    &times;
                </button>

                <div className={styles.hintsScroll}>
                    {hintsArray.map((hint, idx) => (
                        <div key={idx} className={styles.hint}>
                            {hint}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Hints;
